export default "__VITE_ASSET__Dmom0sKf__"